import * as React from "react";

const AnalyticsIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    height="1.1em"
    width="1em"
    viewBox="0 0 21 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.72852 22.5371H0.228516V17.0371H5.72852V22.5371ZM13.0618 14.2871H7.56185V22.5371H13.0618V14.2871ZM20.3952 10.6204H14.8952V22.5371H20.3952V10.6204ZM20.3952 0.537109L14.8952 1.65636L16.4682 3.22203L10.189 9.39394L7.4381 6.64211L0.250516 13.7894L1.54302 15.0892L7.43443 9.23169L10.1762 11.9753L17.7662 4.51636L19.2943 6.03803L20.3952 0.537109V0.537109Z"
      fill="currentColor"
    />
  </svg>
);

export default AnalyticsIcon;
